/*
 *
 * ProtectionPlusModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 01-Aug-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import { Open } from '@nexidigital/iconlibrary'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import PortalProgressStepper from '@nexidigital/portalprogressstepper'
import formattedMessage from './languageModule'

const ProtectionPlusModal = (props) => (
  <Toggle>
    <MerchantModal
      primaryButtonTertiary
      onClose={() => props.actions.doHidePopup()}
      topBarTitle={formattedMessage.modalTitle}
      primaryButtonLabel={formattedMessage.modalPrimaryButton}
      primaryAction={() => props.actions.doHidePopup()}
      primaryIcon={<Open size='20' type='line' />}
      customAnalyticsDescription={formattedMessage.modalDescriptionTop}
    >
      <div className='pciModalPPContent'>
        <MerchantGenericCard>
          <p>{formattedMessage.modalDescriptionTop}</p>
          <div className='pciModalProtectionQuote'>
            <p>{formattedMessage.modalProtectionQuote}</p>
          </div>
          <div className='pciModalProtectionSource'>
            <p>{formattedMessage.modalProtectionSource}</p>
            <p>{formattedMessage.modalDescriptionBottom}</p>
            <p>{formattedMessage.modalProtectionProgressText} </p>
          </div>
          <div>
            <PortalProgressStepper
              steps={[
                {
                  title: formattedMessage.portalProgressStepper1,
                  normalWeight: true
                },
                {
                  title: formattedMessage.portalProgressStepper2,
                  normalWeight: true
                },
                {
                  title: formattedMessage.portalProgressStepper3,
                  normalWeight: true
                },
                {
                  title: formattedMessage.portalProgressStepper4,
                  normalWeight: true
                }
              ]}
            />
          </div>
          <div>
            <p className='pciModalStepperTitle'>{formattedMessage.modalStepperTitle}</p>
            <div>
              <PortalProgressStepper
                steps={[
                  {
                    title: formattedMessage.portalProgressStepper5,
                    normalWeight: true
                  },
                  {
                    title: formattedMessage.portalProgressStepper6,
                    normalWeight: true
                  },
                  {
                    title: formattedMessage.portalProgressStepper7,
                    normalWeight: true
                  },
                  {
                    title: formattedMessage.portalProgressStepper8,
                    normalWeight: true
                  }
                ]}
              />
            </div>
          </div>
        </MerchantGenericCard>
      </div>
    </MerchantModal>
  </Toggle>
)

ProtectionPlusModal.propTypes = {
  actions: PropTypes.object
}

ProtectionPlusModal.defaultProps = {
  action: {}
}

export default ProtectionPlusModal
